import(/* webpackMode: "eager", webpackExports: ["BookingPage"] */ "/app/apps/tagea-web/src/libs/features/appointments/ui/booking/booking-page.tsx");
